import React, { useEffect, useState } from 'react';
import { translations } from './i18n';
import Header from './components/Header';
import Hero from './components/Hero';
import Ticker from './components/Ticker';
import Problems from './components/Problems';
import Platform from './components/Platform';
import Nutrition from './components/Nutrition';
import Recipes from './components/Recipes';
import Grocery from './components/Grocery';
import Vision from './components/Vision';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';

function App() {
  const [lang, setLang] = useState('no');
  const t = translations[lang];

  useEffect(() => {
    document.documentElement.lang = lang === 'no' ? 'nb' : 'en';
  }, [lang]);

  return (
    <div className="min-h-screen bg-snow font-body text-ink antialiased">
      <Header lang={lang} setLang={setLang} t={t} />
      <main>
        <Hero t={t} />
        <Ticker t={t} />
        <Problems t={t} />
        <Platform t={t} />
        <Nutrition t={t} />
        <Recipes t={t} />
        <Grocery t={t} />
        <Vision t={t} />
        <FinalCTA t={t} />
      </main>
      <Footer t={t} />
    </div>
  );
}

export default App;
